import { $api } from 'api/http'
import { ICheckout } from 'api/types/checkout'

class CheckoutApiService {
  setCheckout(checkout: ICheckout) {
    return $api.post<ICheckout>('/checkout', checkout)
  }
  getCities(query: string) {
    return $api.post('/cities', {
      search: query,
    })
  }
  getStreets({ query, city }: { query: string; city: string }) {
    return $api.post(`/streets/${city}`, {
      search: query,
    })
  }
  getPostoffices({ query, city }: { query: string; city: string }) {
    return $api.post(`/postoffices/${city}`, {
      search: query,
    })
  }
}

export const checkoutApiService = new CheckoutApiService()
